<template>
  <div>
      <component
        v-for="(field, index) in schema"
        :key="index"
        :is="field.fieldType"
        :value="formData[field.fieldName]"
        @input="updateForm(field.fieldName, $event)"
        v-bind="field"
      ></component>
    </div>
</template>

<script>
import NumberInput from "./NumberInput";
import Dropdown from "./SelectList";
import Textbox from "./TextInput";
import Datetime from "./Datetime";
import Toggle from "./Toggle"
import Textarea from "./Textarea"

export default {
  name: "FormGenerator",
  components: { NumberInput, Textarea,Dropdown, Textbox, Datetime,Toggle },
  props: ["schema", "value"],
  data() {
    return {
      formData: this.value || {}
    };
  },
  methods: {
    updateForm(fieldName, Value) {
      this.$set(this.formData, fieldName, Value);
      this.$emit("input", this.formData);
    }
  },
  mounted() {
    // console.log("schema", this.schema);
  }
};
</script>
